// NOTE: This file must be imported in order to initialize logger.

import { getLogger } from './getLogger';
import { Logger } from './loggerTypes';

declare global {
  var logger: Logger;
}

if (!globalThis.logger) {
  const _logger: Logger = {
    debug: getLogger('debug'),
    error: getLogger('error'),
    info: getLogger('info'),
    warn: getLogger('warn')
  };

  // Add logger to globalThis, so it can be used without import
  globalThis.logger = _logger;

  // NOTE: Select verbose logging in the browser console to see this message
  globalThis.logger.debug('logger initialized');
}
